import React from 'react';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return '$0';
  return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const BankLendingExecSummary = ({ investorResult, borrowerResult }) => {
  if (!investorResult || !borrowerResult) {
    return <div className="text-center text-gray-500">No data available.</div>;
  }

  return (
    <div className="bg-blue-50 p-6 rounded-lg text-sm text-gray-800 leading-relaxed space-y-4">
      <h3 className="text-lg font-bold text-blue-900">Executive Summary</h3>
      <p>
        This model simulates a <strong>conventional mortgage</strong> over a <strong>{investorResult.termYears}-year</strong> fixed term. 
        A lender provides <strong>{formatCurrency(investorResult.originalLoanAmount)}</strong> in capital to an entrepreneur who repays it through 
        equal monthly installments consisting of principal and interest.
      </p>
      <p>
        The investor earns interest over time while receiving regular principal repayments. There is no shared ownership, 
        no rent income, and no reinvestment — this model reflects the current real-world mortgage structure used globally by financial institutions.
      </p>

      <h4 className="font-semibold text-blue-800">💰 Investor (Lender) Highlights</h4>
      <ul className="list-disc list-inside space-y-1">
        <li>Capital Invested: <strong>{formatCurrency(investorResult.originalLoanAmount)}</strong></li>
        <li>Interest Earned Over Time: <strong>{formatCurrency(investorResult.netCashflow)}</strong></li>
        <li>Total Exit Value: <strong>{formatCurrency(investorResult.exitValue)}</strong></li>
        <li>Total ROI: <strong>{investorResult.totalROI}%</strong></li>
        <li>IRR Estimate: <strong>{investorResult.irrEstimate}%</strong></li>
        <li>Loan Term: <strong>{investorResult.termYears} years</strong></li>
      </ul>

      <h4 className="font-semibold text-purple-800">🏠 Entrepreneur (Borrower) Highlights</h4>
      <ul className="list-disc list-inside space-y-1">
        <li>Monthly Payment: <strong>{formatCurrency(borrowerResult.monthlyPayment)}</strong></li>
        <li>Total Principal Paid: <strong>{formatCurrency(borrowerResult.totalBuyout)}</strong></li>
        <li>Total Interest Paid: <strong>{formatCurrency(borrowerResult.totalRentPaid)}</strong></li>
        <li>Total Expenses (Tax + Insurance + Maintenance): <strong>{formatCurrency(borrowerResult.totalExpenses)}</strong></li>
        <li>Total Paid Over Time: <strong>{formatCurrency(borrowerResult.totalPayment)}</strong></li>
        <li>Total Equity Accrued: <strong>{formatCurrency(borrowerResult.equityBuilt)}</strong></li>
        <li>Exit Value (Asset − Sell Cost − Expenses): <strong>{formatCurrency(borrowerResult.exitValue)}</strong></li>
        <li>Loan Term: <strong>{borrowerResult.termYears} years</strong></li>
      </ul>
    </div>
  );
};

export default BankLendingExecSummary;
